import React from "react";
import { RiFileExcel2Line } from "react-icons/ri";
import * as XLSX from "xlsx";
import {
  formatNumberV2,
  formatDateISO,
  formatDate,
  ceil2Decimal,
  formatDateFromUnix,
  getMinuteTimeV2,
  formatDateISOToTh,
} from "../../utilities/Format";
import { format } from "date-fns";
import { OperationTime } from "../../constants/Enum";
import { AvgFwtByLot, DgtPdOrderOperationLog } from "../../models";
import { groupBy } from "lodash";
import { calculateYieldFilling, calculateYieldPacking } from "../../logic/yield";
import { OrderInspectionLog, OrderReceipt } from "../types";

function GenerateExcel(props: any) {
  const createExcel = () => {
    const workbook = XLSX.utils.book_new();

    const dataHeader = [
      {
        "Production Order": `${
          props.data.order.id ? props.data.order.id : "-"
        }`,
        Quantity: `${
          props.data.order.orderQty
            ? formatNumberV2(props.data.order.orderQty || 0)
            : "-"
        } ${
          props.data.order.materialUnit ? props.data.order.materialUnit : "-"
        }`,
        Material: `${
          props.data.order.materialDescription
            ? props.data.order.materialDescription
            : "-"
        }`,
      },
    ];

    if (dataHeader.length > 0) {
      const worksheetHeader = XLSX.utils.json_to_sheet(dataHeader);
      XLSX.utils.book_append_sheet(workbook, worksheetHeader, "Header");
    }

    const dataGereralInformation = [
      {
        "Order No": `${props.data.order.id ? props.data.order.id : "-"}`,
        "Material Code": `${
          props.data.order.materialCode ? props.data.order.materialCode : "-"
        }`,
        "Material Desc": `${
          props.data.order.materialDescription
            ? props.data.order.materialDescription
            : "-"
        }`,
        "Barcode EAN": `${
          props.data.order.barcodeFgCase!
            ? props.data.order.barcodeFgCase!
            : "-"
        }`,
        Division: `${
          props.data.order.division! ? props.data.order.division! : "-"
        }`,
        "Qty / Actual": `${
          props.data.order.orderQty
            ? formatNumberV2(props.data.order.orderQty || 0)
            : "-"
        } / ${
          props.data.actualQty ? formatNumberV2(props.data.actualQty) : "-"
        } ${
          props.data.order.materialUnit ? props.data.order.materialUnit : "-"
        }`,
        "Released Date": `${
          props.data.order.createdAt
            ? formatDateISO(props.data.order.createdAt)
            : "-"
        }`,
        "Released By": `${
          props.data.order.releasedBy! ? props.data.order.releasedBy! : "-"
        }`,
        "Actual Due Date": `${
          props.data.order.actualDueDate!
            ? formatDate(props.data.order.actualDueDate!)
            : "-"
        }`,
        "Actual Batch Lots": `${
          props.data.order.actualBatchNumbers
            ? (
                JSON.parse(props.data.order.actualBatchNumbers) as string[]
              ).join(", ")
            : "-"
        }`,
        "Trial Batch": `${
          props.data.order.trialBatch! ? props.data.order.trialBatch! : "-"
        }`,
        "Order Status": `${
          props.data.order.statusFromApp!
            ? convertOrderStatus(props.data.order.statusFromApp!)
            : "-"
        }`,
        "Product Profle": `${
          props.data.order.infoFwt
            ? props.data.order.infoFwt
            : props.data.order.infoEffBulkDate
            ? props.data.order.infoEffBulkDate
            : props.data.order.infoRefPkg
            ? props.data.order.infoRefPkg
            : props.data.order.infoPallet
            ? props.data.order.infoPallet
            : props.data.order.infoPacking
            ? props.data.order.infoPacking
            : "-"
        }`,
        "Picklist Status": `${
          props.data.picklistStatus!
            ? convertPicklistStatus(props.data.picklistStatus!)
            : "-"
        }`,
      },
      {
        "Order No": "",
        "Material Code": "",
        "Material Desc": "",
        "Barcode EAN": "",
        Division: "",
        "Qty / Actual": "",
        "Released Date": "",
        "Released By": "",
        "Actual Due Date": "",
        "Actual Batch Lots": "",
        "Trial Batch": "",
        "Order Status": "",
        "Product Profle": `${
          props.data.order.infoEffBulkDate
            ? props.data.order.infoEffBulkDate
            : props.data.order.infoRefPkg
            ? props.data.order.infoRefPkg
            : props.data.order.infoPallet
            ? props.data.order.infoPallet
            : props.data.order.infoPacking
            ? props.data.order.infoPacking
            : ""
        }`,
        "Picklist Status": "",
      },
      {
        "Order No": "",
        "Material Code": "",
        "Material Desc": "",
        "Barcode EAN": "",
        Division: "",
        "Qty / Actual": "",
        "Released Date": "",
        "Released By": "",
        "Actual Due Date": "",
        "Actual Batch Lots": "",
        "Trial Batch": "",
        "Order Status": "",
        "Product Profle": `${
          props.data.order.infoRefPkg
            ? props.data.order.infoRefPkg
            : props.data.order.infoPallet
            ? props.data.order.infoPallet
            : props.data.order.infoPacking
            ? props.data.order.infoPacking
            : ""
        }`,
        "Picklist Status": "",
      },
      {
        "Order No": "",
        "Material Code": "",
        "Material Desc": "",
        "Barcode EAN": "",
        Division: "",
        "Qty / Actual": "",
        "Released Date": "",
        "Released By": "",
        "Actual Due Date": "",
        "Actual Batch Lots": "",
        "Trial Batch": "",
        "Order Status": "",
        "Product Profle": `${
          props.data.order.infoPallet
            ? props.data.order.infoPallet
            : props.data.order.infoPacking
            ? props.data.order.infoPacking
            : ""
        }`,
        "Picklist Status": "",
      },
      {
        "Order No": "",
        "Material Code": "",
        "Material Desc": "",
        "Barcode EAN": "",
        Division: "",
        "Qty / Actual": "",
        "Released Date": "",
        "Released By": "",
        "Actual Due Date": "",
        "Actual Batch Lots": "",
        "Trial Batch": "",
        "Order Status": "",
        "Product Profle": `${
          props.data.order.infoPacking ? props.data.order.infoPacking : ""
        }`,
        "Picklist Status": "",
      },
    ];

    if (dataGereralInformation.length > 0) {
      const worksheetGereralInformation = XLSX.utils.json_to_sheet(
        dataGereralInformation
      );
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetGereralInformation,
        "Gereral Information"
      );
    }

    for (const operation of props.data.operations) {
      const dataProductionLogs = [];
      const logs = props.data.operationLogs.filter(
        (log: any) => log.operationNo === operation.operationNo
      );
      const totalYield = ceil2Decimal(
        logs.reduce((prev: any, { yield: y }: any) => prev + (y || 0), 0)
      );

      const dataOrderConfirmOpLogs = [
        [
          "Type",
          "Batch No",
          "Mch",
          "Split",
          "Posting Date",
          "Shift",
          "เริ่ม",
          "จบ",
          "เวลารวม",
          "RT",
          "OT",
          "ผลิตได้",
          "ของเสีย",
          "ใช้Bulk",
          "บันทึกโดย",
          "ยืนยันโดย",
          "เวลายืนยัน",
        ],
      ];

      for (const log of logs) {
        const dataOrderConfirmOpTotalTime = () => {
          if (log.timeType === OperationTime.DOWN_TIME) {
            if (!log.totalTime) return "-";
            if (!log.downtimeBaseTime)
              return `${getMinuteTimeV2(
                log.startedTime,
                log.finishedTime
              )} นาที`;
            return `${getRemainTime(log)} นาที`;
          }
          return log.totalTime
            ? `${getMinuteTimeV2(log.startedTime, log.finishedTime)} นาที`
            : "-";
        };

        const dataOrderConfirmOpRT = () => {
          if (log.timeType === OperationTime.DOWN_TIME) {
            return log.totalTime! > 0 && log.totalEmployeeRT! > 0
              ? `${log.totalEmployeeRT} คน/${
                  getRemainTime(log) * log.totalEmployeeRT!
                } นาที`
              : "-";
          }
          return log.totalTime! >= 0 && log.totalEmployeeRT! > 0
            ? `${log.totalEmployeeRT} คน/${
                getMinuteTimeV2(log.startedTime, log.finishedTime) *
                log.totalEmployeeRT!
              } นาที`
            : "-";
        };

        const dataOrderConfirmOpOT = () => {
          if (log.timeType === OperationTime.DOWN_TIME) {
            return log.totalTime! > 0 && log.totalEmployeeOT! > 0
              ? `${log.totalEmployeeOT} คน/${
                  getRemainTime(log) * log.totalEmployeeOT!
                } นาที`
              : "-";
          }
          return log.totalTime! >= 0 && log.totalEmployeeOT! > 0
            ? `${log.totalEmployeeOT} คน/${
                getMinuteTimeV2(log.startedTime, log.finishedTime) *
                log.totalEmployeeOT!
              } นาที`
            : "-";
        };

        const dataOrderConfirmOpYield = () => {
          if (log.timeType === OperationTime.SOAP_BASE) {
            return log.bulkUsedQty ? formatNumberV2(log.bulkUsedQty) : "-";
          }
          return log.yield ? formatNumberV2(log.yield) : "-";
        };

        dataOrderConfirmOpLogs.push([
          log.timeType ? log.timeType : "-",
          log.batchNo ? log.batchNo : "-",
          log.mch ? log.mch : "-",
          log.split ? log.split : "-",
          log.postingDate
            ? format(new Date(log.postingDate), "dd-MM-yyyy")
            : "-",
          log.shift ? log.shift : "-",
          log.startedTime
            ? format(new Date(log.startedTime * 1000), "HH:mm")
            : "-",
          log.finishedTime
            ? format(new Date(log.finishedTime * 1000), "HH:mm")
            : "-",
          dataOrderConfirmOpTotalTime(),
          dataOrderConfirmOpRT(),
          dataOrderConfirmOpOT(),
          dataOrderConfirmOpYield(),
          log.scrap ? formatNumberV2(log.scrap) : "-",
          log.bulkUsedQty ? formatNumberV2(log.bulkUsedQty) : "-",
          log.createdBy ? log.createdBy.split("@")[0] : "-",
          log.confirmedBy ? log.confirmedBy.split("@")[0] : "-",
          log.confirmedDate ? formatDateISO(log.confirmedDate) : "-",
        ]);
      }

      dataProductionLogs.push(
        [
          `OP. ${operation.operationNo} - ${
            operation.actualWorkCenterDescription
              ? operation.actualWorkCenterDescription
              : operation.workCenterDescription
          } (${
            operation.actualWorkCenterId
              ? operation.actualWorkCenterId
              : operation.workCenterId
          })`,
        ],
        [
          "Confirmation No: ",
          operation.confirmationId! ? operation.confirmationId! : "-",
        ],
        ["Drafted By: ", operation.draftedBy! ? operation.draftedBy! : "-"],
        [
          "Drafted Time: ",
          operation.draftedDate ? formatDateISO(operation.draftedDate) : "-",
        ],
        [
          "Actual Qty: ",
          totalYield
            ? `${formatNumberV2(totalYield)} ${props.data.order.materialUnit}`
            : "-",
        ],
        [
          "Confirmed By: ",
          operation.confirmedBy! ? operation.confirmedBy! : "-",
        ],
        [
          "Confirmed Time: ",
          operation.confirmedDate
            ? formatDateISO(operation.confirmedDate)
            : "-",
        ],
        [],
        ...dataOrderConfirmOpLogs,
        []
      );

      if (dataProductionLogs.length > 0) {
        const worksheetProductionLogs =
          XLSX.utils.json_to_sheet(dataProductionLogs);
        delete_row(worksheetProductionLogs, 0);
        XLSX.utils.book_append_sheet(
          workbook,
          worksheetProductionLogs,
          `Production Logs (OP. ${
            operation.operationNo ? operation.operationNo : "-"
          })`
        );
      }
    }

    const dataInspection = [];
    for (const bulkInspectLog of props.data.bulkInspectLogs) {
      dataInspection.push({
        เริ่มตรวจเมื่อ: `${
          bulkInspectLog.createdBy
            ? bulkInspectLog.startedTime
              ? `${bulkInspectLog.createdBy.split("@")[0]} ${formatDateFromUnix(
                  bulkInspectLog.startedTime
                )}`
              : bulkInspectLog.createdBy.split("@")[0]
            : "-"
        }`,
        ตรวจเสร็จเมื่อ: `${
          bulkInspectLog.bulkStatusBy
            ? bulkInspectLog.finishedTime
              ? `${
                  bulkInspectLog.bulkStatusBy.split("@")[0]
                } ${formatDateFromUnix(bulkInspectLog.finishedTime)}`
              : bulkInspectLog.bulkStatusBy.split("@")[0]
            : "-"
        }`,
        เวลาที่ใช้: `${
          bulkInspectLog.totalTime
            ? getMinuteTimeV2(
                bulkInspectLog.startedTime,
                bulkInspectLog.finishedTime
              )
            : "-"
        }`,
        "Bulk Status": `${
          bulkInspectLog.bulkStatus ? bulkInspectLog.bulkStatus : "-"
        }`,
        บันทึกเมื่อ: `${
          bulkInspectLog.bulkStatusBy
            ? bulkInspectLog.bulkStatusDateTime
              ? `${
                  bulkInspectLog.bulkStatusBy.split("@")[0]
                } ${formatDateFromUnix(bulkInspectLog.bulkStatusDateTime)}`
              : bulkInspectLog.bulkStatusBy.split("@")[0]
            : "-"
        }`,
        "Bulk Comment": `${
          bulkInspectLog.bulkStatusComment
            ? bulkInspectLog.bulkStatusComment.split("@")[0]
            : "-"
        }`,
        อนุมัติเมื่อ: `${
          bulkInspectLog.approveBulkStatusBy
            ? bulkInspectLog.approveBulkStatusDateTime
              ? `${
                  bulkInspectLog.approveBulkStatusBy.split("@")[0]
                } ${formatDateFromUnix(
                  bulkInspectLog.approveBulkStatusDateTime
                )}`
              : bulkInspectLog.approveBulkStatusBy.split("@")[0]
            : "-"
        }`,
      });
    }

    if (dataInspection.length > 0) {
      const worksheetInspection = XLSX.utils.json_to_sheet(dataInspection);
      XLSX.utils.book_append_sheet(workbook, worksheetInspection, "Inspection");
    }

    // BOM Usage addOnAndSortedMvs
    const dataAddOnAndSortedMvs = [];
    const groupAddOnAndSortedMvs = groupBy(
      props.data.addOnAndSortedMvs,
      "materialCode"
    );
    for (const groupAddOnAndSortedMv of Object.entries(
      groupAddOnAndSortedMvs
    )) {
      const uniqueQtys = new Set(
        (groupAddOnAndSortedMv[1] as []).map(
          (row: any) => row.materialRequestQty || 0
        )
      );
      const sumQty = Array.from(uniqueQtys).reduce(
        (prev: any, qty: any) => prev + qty,
        0
      );
      let LengthGroupAddOnAndSortedMv = (groupAddOnAndSortedMv[1] as []).length;
      let tempCountGroupAddOnAndSortedMv = 0;
      for (const addOnAndSortedMv of groupAddOnAndSortedMv[1] as []) {
        tempCountGroupAddOnAndSortedMv++;
        const dataMaterialRequestQty = () => {
          if (addOnAndSortedMv["materialType"] === "BULK") {
            const tempMaterialRequestQty = (
              groupAddOnAndSortedMv[1] as []
            ).reduce(
              (prev: any, { materialRequestQty }: any) =>
                prev + (materialRequestQty || 0),
              0
            );
            return tempMaterialRequestQty
              ? formatNumberV2(tempMaterialRequestQty)
              : 0;
          }
          return sumQty ? formatNumberV2(sumQty) : 0;
        };
        if (LengthGroupAddOnAndSortedMv > 1) {
          if (tempCountGroupAddOnAndSortedMv === LengthGroupAddOnAndSortedMv) {
            dataAddOnAndSortedMvs.push(
              {
                "รหัส Mat": "",
                "ชื่อ Mat": "",
                เบิก: "",
                จ่าย: "",
                หน่วย: "",
                เวลาจ่าย:
                  addOnAndSortedMv["materialType"] === "BULK"
                    ? addOnAndSortedMv["approvedDateTime"]
                      ? formatDateFromUnix(addOnAndSortedMv["approvedDateTime"])
                      : "-"
                    : addOnAndSortedMv["documentCreatedAt"]
                    ? formatDateFromUnix(addOnAndSortedMv["documentCreatedAt"])
                    : "-",
                ใช้ดี: addOnAndSortedMv["usedGoodQty"]
                  ? formatNumberV2(addOnAndSortedMv["usedGoodQty"])
                  : 0,
                ใช้เสีย: addOnAndSortedMv["usedWasteQty"]
                  ? formatNumberV2(addOnAndSortedMv["usedWasteQty"])
                  : 0,
                คืนดี: addOnAndSortedMv["returnGoodQty"]
                  ? formatNumberV2(addOnAndSortedMv["returnGoodQty"])
                  : 0,
                "คืนดีติดSH/STK": addOnAndSortedMv["returnGoodShrinkQty"]
                  ? formatNumberV2(addOnAndSortedMv["returnGoodShrinkQty"])
                  : 0,
                คืนเสีย: addOnAndSortedMv["returnWasteQty"]
                  ? formatNumberV2(addOnAndSortedMv["returnWasteQty"])
                  : 0,
                "Batch No": addOnAndSortedMv["batchLotNo"]
                  ? addOnAndSortedMv["batchLotNo"]
                  : "-",
                หมายเหตุ: addOnAndSortedMv["isExtra"] ? "เบิกเพิ่ม" : "",
                "Vendor Batch": addOnAndSortedMv["vendorLotNo"]
              },
              {
                "รหัส Mat": "",
                "ชื่อ Mat": "",
                เบิก: "",
                จ่าย: "",
                หน่วย: "",
                เวลาจ่าย: "Summary",
                ใช้ดี: formatNumberV2(
                  (groupAddOnAndSortedMv[1] as []).reduce(
                    (prev, { usedGoodQty }) => prev + usedGoodQty!,
                    0
                  )
                ),
                ใช้เสีย: formatNumberV2(
                  (groupAddOnAndSortedMv[1] as []).reduce(
                    (prev, { usedWasteQty }) => prev + usedWasteQty!,
                    0
                  )
                ),
                คืนดี: formatNumberV2(
                  (groupAddOnAndSortedMv[1] as []).reduce(
                    (prev, { returnGoodQty }) => prev + returnGoodQty!,
                    0
                  )
                ),
                "คืนดีติดSH/STK": formatNumberV2(
                  (groupAddOnAndSortedMv[1] as []).reduce(
                    (prev, { returnGoodShrinkQty }) =>
                      prev + returnGoodShrinkQty!,
                    0
                  )
                ),
                คืนเสีย: formatNumberV2(
                  (groupAddOnAndSortedMv[1] as []).reduce(
                    (prev, { returnWasteQty }) => prev + returnWasteQty!,
                    0
                  )
                ),
                "Batch No": "",
                หมายเหตุ: addOnAndSortedMv["isExtra"] ? "เบิกเพิ่ม" : "",
                "Vendor Batch": addOnAndSortedMv["vendorLotNo"]
              }
            );
          } else {
            dataAddOnAndSortedMvs.push({
              "รหัส Mat": addOnAndSortedMv["materialCode"]
                ? addOnAndSortedMv["materialCode"]
                : "-",
              "ชื่อ Mat": addOnAndSortedMv["materialDescription"]
                ? addOnAndSortedMv["materialDescription"]
                : "-",
              เบิก: dataMaterialRequestQty(),
              จ่าย: formatNumberV2(
                (groupAddOnAndSortedMv[1] as []).reduce(
                  (prev: any, { amount }: any) => prev + amount,
                  0
                )
              ),
              หน่วย: addOnAndSortedMv["materialUnit"],
              เวลาจ่าย:
                addOnAndSortedMv["materialType"] === "BULK"
                  ? addOnAndSortedMv["approvedDateTime"]
                    ? formatDateFromUnix(addOnAndSortedMv["approvedDateTime"])
                    : "-"
                  : addOnAndSortedMv["documentCreatedAt"]
                  ? formatDateFromUnix(addOnAndSortedMv["documentCreatedAt"])
                  : "-",
              ใช้ดี: addOnAndSortedMv["usedGoodQty"]
                ? formatNumberV2(addOnAndSortedMv["usedGoodQty"])
                : 0,
              ใช้เสีย: addOnAndSortedMv["usedWasteQty"]
                ? formatNumberV2(addOnAndSortedMv["usedWasteQty"])
                : 0,
              คืนดี: addOnAndSortedMv["returnGoodQty"]
                ? formatNumberV2(addOnAndSortedMv["returnGoodQty"])
                : 0,
              "คืนดีติดSH/STK": addOnAndSortedMv["returnGoodShrinkQty"]
                ? formatNumberV2(addOnAndSortedMv["returnGoodShrinkQty"])
                : 0,
              คืนเสีย: addOnAndSortedMv["returnWasteQty"]
                ? formatNumberV2(addOnAndSortedMv["returnWasteQty"])
                : 0,
              "Batch No": addOnAndSortedMv["batchLotNo"]
                ? addOnAndSortedMv["batchLotNo"]
                : "-",
              หมายเหตุ: addOnAndSortedMv["isExtra"] ? "เบิกเพิ่ม" : "",
              "Vendor Batch": addOnAndSortedMv["vendorLotNo"]
            });
          }
        } else {
          dataAddOnAndSortedMvs.push({
            "รหัส Mat": addOnAndSortedMv["materialCode"]
              ? addOnAndSortedMv["materialCode"]
              : "-",
            "ชื่อ Mat": addOnAndSortedMv["materialDescription"]
              ? addOnAndSortedMv["materialDescription"]
              : "-",
            เบิก: dataMaterialRequestQty(),
            จ่าย: formatNumberV2(
              (groupAddOnAndSortedMv[1] as []).reduce(
                (prev: any, { amount }: any) => prev + amount,
                0
              )
            ),
            หน่วย: addOnAndSortedMv["materialUnit"],
            เวลาจ่าย:
              addOnAndSortedMv["materialType"] === "BULK"
                ? addOnAndSortedMv["approvedDateTime"]
                  ? formatDateFromUnix(addOnAndSortedMv["approvedDateTime"])
                  : "-"
                : addOnAndSortedMv["documentCreatedAt"]
                ? formatDateFromUnix(addOnAndSortedMv["documentCreatedAt"])
                : "-",
            ใช้ดี: addOnAndSortedMv["usedGoodQty"]
              ? formatNumberV2(addOnAndSortedMv["usedGoodQty"])
              : 0,
            ใช้เสีย: addOnAndSortedMv["usedWasteQty"]
              ? formatNumberV2(addOnAndSortedMv["usedWasteQty"])
              : 0,
            คืนดี: addOnAndSortedMv["returnGoodQty"]
              ? formatNumberV2(addOnAndSortedMv["returnGoodQty"])
              : 0,
            "คืนดีติดSH/STK": addOnAndSortedMv["returnGoodShrinkQty"]
              ? formatNumberV2(addOnAndSortedMv["returnGoodShrinkQty"])
              : 0,
            คืนเสีย: addOnAndSortedMv["returnWasteQty"]
              ? formatNumberV2(addOnAndSortedMv["returnWasteQty"])
              : 0,
            "Batch No": addOnAndSortedMv["batchLotNo"]
              ? addOnAndSortedMv["batchLotNo"]
              : "-",
            หมายเหตุ: addOnAndSortedMv["isExtra"] ? "เบิกเพิ่ม" : "",
            "Vendor Batch": addOnAndSortedMv["vendorLotNo"]
          });
        }
      }
    }

    // BOM Usage extras
    const dataBomUsageExtras = [];
    for (const extra of props.data.extras) {
      const withdrawalList = () => {
        const items = extra.items ? JSON.parse(extra.items) : [];
        return items.map((itm: any) => {
          return `${itm.materialCode} - ${itm.materialDescription} = ${itm.qty} ${itm.materialUnit} \n`;
        });
      };
      dataBomUsageExtras.push({
        รายการเบิก:
          withdrawalList().length > 0 ? withdrawalList().toString() : "-",
        ขอเบิกโดย: extra.requestedBy
          ? extra.requestedDateTime
            ? `${extra.requestedBy} ${formatDateFromUnix(
                extra.requestedDateTime
              )}`
            : extra.requestedBy
          : "-",
        อนุมัติเบิกโดย: extra.approvedBy
          ? extra.approvedDateTime
            ? `${extra.approvedBy} ${formatDateFromUnix(
                extra.approvedDateTime
              )}`
            : extra.approvedBy
          : "-",
        สถานะ: extra.status! ? extra.status! : "-",
        หมายเหตุ: extra.remark ? extra.remark : "",
      });
    }

    // BOM Usage packageReasonCodes
    const dataBomUsagePackageReasonCodes = [];
    for (const packageReasonCode of props.data.packageReasonCodes) {
      const reasons = packageReasonCode.reasonCodes
        ? JSON.parse(packageReasonCode.reasonCodes)
        : [];
      const totalScrap = ceil2Decimal(
        reasons.reduce((prev: any, cur: any) => prev + Number(cur.quantity), 0)
      );
      const reasonsList = () => {
        return reasons
          .filter((reason: any) => Number(reason.quantity) > 0)
          .map((res: any) => {
            return `${res.reasonDescription ? res.reasonDescription : "-"} ${
              res.quantity ? formatNumberV2(res.quantity) : "-"
            } ${packageReasonCode.unit ? packageReasonCode.unit : "-"}\n`;
          });
      };
      if (totalScrap > 0) {
        dataBomUsagePackageReasonCodes.push({
          Description: `${
            packageReasonCode.materialDescription
              ? packageReasonCode.materialDescription
              : "-"
          } (${
            packageReasonCode.labOffice ? packageReasonCode.labOffice : "-"
          })`,
          Code: packageReasonCode.materialCode
            ? packageReasonCode.materialCode
            : "-",
          "Reason Description":
            reasonsList().length > 0 ? reasonsList().toString() : "-",
          "Total Scrap": totalScrap,
          Confirmed: `${
            packageReasonCode.confirmedBy
              ? packageReasonCode.confirmedDate
                ? `${
                    packageReasonCode.confirmedBy.split("@")[0]
                  } (${formatDateISO(packageReasonCode.confirmedDate)}`
                : packageReasonCode.confirmedBy
              : "-"
          }`,
        });
      }
    }

    // BOM Usage wasteRejectPkgMvs
    const dataBomUsageWasteRejectPkgMvs = [];
    for (const wasteRejectPkgMv of props.data.wasteRejectPkgMvs) {
      const totalReject = ceil2Decimal(
        wasteRejectPkgMv.rejectLots.reduce(
          (prev: any, cur: any) => prev + Number(cur.returnWasteQty),
          0
        )
      );
      const firstLot = wasteRejectPkgMv.rejectLots[0];
      const wasteRejectPkgMvList = () => {
        return wasteRejectPkgMv.rejectLots.map((wrprl: any) => {
          return `LOT : ${wrprl.batchLotNo ? wrprl.batchLotNo : "-"} ${
            wrprl.returnWasteQty ? formatNumberV2(wrprl.returnWasteQty) : "-"
          } ${wrprl.materialUnit ? wrprl.materialUnit : "-"}\nบันทึกโดย ${
            wrprl.recordedBy ? wrprl.recordedBy : "-"
          } (${
            wrprl.recordedDateTime
              ? formatDateFromUnix(wrprl.recordedDateTime)
              : "-"
          })\nอนุมัติโดย QC ${
            wrprl.approvedWasteReturnBy ? wrprl.approvedWasteReturnBy : "-"
          } (${
            wrprl.approvedWasteReturnDateTime
              ? formatDateFromUnix(wrprl.approvedWasteReturnDateTime)
              : "-"
          })\n`;
        });
      };
      dataBomUsageWasteRejectPkgMvs.push({
        Description: `${
          firstLot.materialDescription ? firstLot.materialDescription : "-"
        }`,
        Code: wasteRejectPkgMv.materialCode
          ? wasteRejectPkgMv.materialCode
          : "-",
        Details:
          wasteRejectPkgMvList().length > 0
            ? wasteRejectPkgMvList().toString()
            : "-",
        "Total Reject": `${totalReject ? formatNumberV2(totalReject) : "-"} ${
          firstLot.materialUnit ? firstLot.materialUnit : "-"
        }`,
      });
    }

    // BOM Usage returns
    const dataBomUsageReturns = [];
    for (const ret of props.data.returns) {
      const returnCal = () => {
        return ret
          .extraReturnItems!.filter(
            (retItm: any) =>
              (retItm?.qty || retItm?.withShQty || retItm?.wasteQty!) > 0
          )
          .map((retItm: any) => {
            let returnType = "ปกติ";
            if (retItm?.withShQty! > 0) {
              returnType = "ติด SH/STK";
            }
            if (retItm?.wasteQty! > 0) {
              returnType = "เสีย Reject";
            }
            return `${retItm?.materialCode} - ${retItm?.materialDescription}
                    Batch Lot : ${retItm?.batchLotNo}
                    Qty : ${formatNumberV2(
                      retItm?.qty || retItm?.withShQty || retItm?.wasteQty
                    )} ${retItm?.materialUnit} ${returnType}
                    ${
                      retItm?.returnStorageLocation
                        ? retItm?.returnStorageLocation
                        : retItm?.wasteQty! > 0
                        ? "LREJ"
                        : "Loc เดิม"
                    }`;
          });
      };
      dataBomUsageReturns.push({
        รายการคืนของ_คืนโดย: ret.requestedBy ? ret.requestedBy : "-",
        รายการคืนของ_คืนเมื่อ: ret.requestedDateTime
          ? formatDateFromUnix(ret.requestedDateTime)
          : "-",
        รายการคืนของ_รับโดย: ret.approvedBy ? ret.approvedBy : "-",
        รายการคืนของ_รับเมื่อ: ret.approvedDateTime
          ? formatDateFromUnix(ret.approvedDateTime)
          : "-",
        "รายการคืนของ_Header Text": ret.remark ? ret.remark : "-",
        "รายการคืนของ_Mat. Doc": ret.documentNo ? ret.documentNo : "-",
        รายการคืนของ_รายการคืน:
          returnCal().length > 0 ? returnCal().toString() : "-",
      });
    }

    if (dataAddOnAndSortedMvs.length > 0) {
      const worksheetBomUsage = XLSX.utils.json_to_sheet(dataAddOnAndSortedMvs);
      XLSX.utils.book_append_sheet(workbook, worksheetBomUsage, "Bom Usage");
    }

    if (dataBomUsageExtras.length > 0) {
      const worksheetBomUsage = XLSX.utils.json_to_sheet(dataBomUsageExtras);
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetBomUsage,
        "Bom Usage (รายการเบิกเพิ่ม)"
      );
    }

    if (dataBomUsagePackageReasonCodes.length > 0) {
      const worksheetBomUsage = XLSX.utils.json_to_sheet(
        dataBomUsagePackageReasonCodes
      );
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetBomUsage,
        "Bom Usage (ใช้เสีย)"
      );
    }

    if (dataBomUsageWasteRejectPkgMvs.length > 0) {
      const worksheetBomUsage = XLSX.utils.json_to_sheet(
        dataBomUsageWasteRejectPkgMvs
      );
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetBomUsage,
        "Bom Usage (คือนเสีย)"
      );
    }

    if (dataBomUsageReturns.length > 0) {
      const worksheetBomUsage = XLSX.utils.json_to_sheet(dataBomUsageReturns);
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetBomUsage,
        "Bom Usage (รายการคืนของ)"
      );
    }

    const dataFGInspectionLogs = props.data.fgInspectionLogs

    if (dataFGInspectionLogs.length > 0) {
      const worksheetFGInspectionLogs = XLSX.utils.json_to_sheet(dataFGInspectionLogs.map((row : OrderInspectionLog) => ({
        'Order No.': row.productionOrderId,
        'Work Center ID': row.workCenterId,
        'Work Center': row.workCenterDescription,
        'Machine ID': row.machineId,
        'Inspection Type': row.inspectionType,
        'Inspection Status': row.inspectionStatus,
        'Form Name': row.formName,
        'Form URL': row.formUrl,
        'Avg. Fwt By Lots': row.avgFwtByLots ? (JSON.parse(row.avgFwtByLots) as AvgFwtByLot[]).map(avg => `${avg.BATCH_LOT}=${avg.AVG_FWT}`).join(',') : '',
        'Submitted Datetime': row.submittedDatetime,
        'Submitted By': row.submittedBy
      })));
      XLSX.utils.book_append_sheet(workbook, worksheetFGInspectionLogs, "FG Inspection Logs");
    }

    const dataOrderReceipts = props.data.orderReceipts.filter((row : OrderReceipt) => !row._deleted)

    const isFilling = props.data.addOnAndSortedMvs.filter((itm: any) => itm.materialType === 'BULK').length > 0

    if (dataOrderReceipts.length > 0) {
      const worksheetOrderReceipts = XLSX.utils.json_to_sheet(dataOrderReceipts.map((row : OrderReceipt) => ({
        'Order No.': row.productionOrderId,
        'Order Type': row.orderType,
        'Material Code': row.orderMaterialCode,
        'Material Description': row.orderMaterialDesc,
        'Lot No.': row.batchLotNo,
        'Bulk Usage': row.bulkUsage,
        'Order Qty': row.orderQty,
        'Actual Qty': row.totalAmount,
        'Avg. Fwt.': row.avgFillingWeight,
        'Total Amount': row.totalAmount,
        '% Yield': isFilling ? calculateYieldFilling(row) : calculateYieldPacking(dataOrderReceipts, props.data.order.orderQty),
        'Retained Issue': row.retainedIssue,
        'Micro Issue': row.microIssue,
        'Validate Issue': row.validateIssue,
        'Shelf Life Issue': row.shelfLifeIssue,
        'Test Issue': row.testIssue,
        'Reject': row.reject,
        'Remark': row.remark,
        'Other Issue': row.otherIssue,
        'Other Note': row.otherIssueNote,
        'Approved By PD': row.approvedByPdBy,
        'Approved Datetime': row.approvedByPdDatetime,
        'Approved By QC': row.approvedByQcBy,
        'Approved By QC Datetime': row.approvedByQcDatetime,
        'Approved By WH': row.approvedByWhBy,
        'Approved By WH Datetime': row.approvedByWhDatetime,
        'Approved By FA': row.approvedByFaBy,
        'Approved By FA Datetime': row.approvedByFaDatetime
      })));
      XLSX.utils.book_append_sheet(workbook, worksheetOrderReceipts, "Order Receipts");
    }

    const dataActivityLogs = [
      {
        ออกเบิกโดย: `${
          props.data.picklist.releasedBy!
            ? props.data.picklist.releasedDate!
              ? `${props.data.picklist.releasedBy!.split("@")[0]} ${props.data
                  .picklist.releasedDate!}`
              : props.data.picklist.releasedBy!.split("@")[0]
            : "-"
        }`,
        อนุมัติเบิกโดย: `${
          props.data.picklist.requestedBy!
            ? props.data.picklist.requestedDateTime
              ? `${
                  props.data.picklist.requestedBy!.split("@")[0]
                } ${formatDateFromUnix(props.data.picklist.requestedDateTime)}`
              : props.data.picklist.requestedBy!.split("@")[0]
            : "-"
        }`,
        อนุมัติจ่ายโดย: `${
          props.data.picklist.approvedBy!
            ? props.data.picklist.approvedDateTime
              ? `${
                  props.data.picklist.approvedBy!.split("@")[0]
                } ${formatDateFromUnix(props.data.picklist.approvedDateTime)}`
              : props.data.picklist.approvedBy!.split("@")[0]
            : "-"
        }`,
        ตรวจรับของโดย: `${
          props.data.picklist.checkedBy!
            ? props.data.picklist.checkedDateTime
              ? `${
                  props.data.picklist.checkedBy!.split("@")[0]
                } ${formatDateFromUnix(props.data.picklist.checkedDateTime)}`
              : props.data.picklist.checkedBy!.split("@")[0]
            : "-"
        }`,
        "ตรวจก่อน Mix โดย": `${
          props.data.picklist.qualityCheckedBy
            ? props.data.picklist.qualityCheckedDateTime
              ? `${
                  props.data.picklist.qualityCheckedBy.split("@")[0]
                } ${formatDateFromUnix(
                  props.data.picklist.qualityCheckedDateTime
                )}`
              : props.data.picklist.qualityCheckedBy.split("@")[0]
            : "-"
        }`,
        เริ่มผลิตโดย: `${
          props.data.firstLog.createdBy!
            ? props.data.firstLog.startedTime
              ? `${
                  props.data.firstLog.createdBy!.split("@")[0]
                } ${formatDateFromUnix(props.data.firstLog.startedTime)}`
              : props.data.firstLog.createdBy!.split("@")[0]
            : "-"
        }`,
        ผลิตจบโดย: `${
          props.data.latestDraftedOp.draftedBy!
            ? props.data.latestDraftedOp.draftedDate
              ? `${
                  props.data.latestDraftedOp.draftedBy!.split("@")[0]
                } ${formatDateISO(
                  props.data.latestDraftedOp.draftedDate,
                  true
                )}`
              : props.data.latestDraftedOp.draftedBy!.split("@")[0]
            : "-"
        }`,
        ยืนยันการผลิตโดย: `${
          props.data.lastOp.confirmedBy!
            ? props.data.lastOp.confirmedDate
              ? `${
                  props.data.lastOp.confirmedBy!.split("@")[0]
                } ${formatDateISO(props.data.lastOp.confirmedDate, true)}`
              : props.data.lastOp.confirmedBy!.split("@")[0]
            : "-"
        }`,
        "อนุมัติของคืน/ปิดเอกสารโดย": `${
          props.data.picklist.completedBy!
            ? props.data.picklist.completedDateTime
              ? `${props.data.picklist.completedBy!} ${formatDateFromUnix(
                  props.data.picklist.completedDateTime
                )}`
              : props.data.picklist.completedBy!
            : "-"
        }`,
        อนุมัติรับคืนโดย: `${
          props.data.returns.length > 0
            ? props.data.returns[props.data.returns.length - 1].approvedBy!
              ? props.data.returns[props.data.returns.length - 1]
                  .approvedDateTime
                ? `${
                    props.data.returns[
                      props.data.returns.length - 1
                    ].approvedBy!.split("@")[0]
                  } ${formatDateFromUnix(
                    props.data.returns[props.data.returns.length - 1]
                      .approvedDateTime
                  )}`
                : props.data.returns[
                    props.data.returns.length - 1
                  ].approvedBy!.split("@")[0]
              : "-"
            : "-"
        }`,
      },
    ];

    if (dataActivityLogs.length > 0) {
      const worksheetActivityLogs = XLSX.utils.json_to_sheet(dataActivityLogs);
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetActivityLogs,
        "Activity Logs"
      );
    }

    const dataComments = [];
    for (const [indexComment, comment] of props.data.comments.entries()) {
      dataComments.push({
        "No.": `${indexComment + 1}`,
        By: `${comment.commentedBy ? comment.commentedBy : "-"}`,
        "Created At": `${
          comment.createdAt ? formatDateISOToTh(comment.createdAt) : "-"
        }`,
        Comment: `${comment.commentText ? comment.commentText : "-"}`,
      });
    }

    if (dataComments.length > 0) {
      const worksheetComments = XLSX.utils.json_to_sheet(dataComments);
      XLSX.utils.book_append_sheet(workbook, worksheetComments, "Comments");
    }

    XLSX.writeFile(
      workbook,
      `REPORT_${props.data.order.id}.xlsx`,
      { compression: true }
    );
  };

  return (
    <button
      className="flex items-center gap-1 btn-outline-success"
      onClick={createExcel}
    >
      <RiFileExcel2Line size={20} />
      Download Excel
    </button>
  );
}

const convertOrderStatus = (status: String) => {
  let label = "";
  if (status === "PD_READY") label = "พร้อมผลิต";
  else if (status === "PD_IN_PROGRESS") label = "กำลังผลิต";
  else if (status === "PD_DRAFTED") label = "ผลิตจบแล้ว";
  else if (status === "PD_CONFIRMED") label = "ยืนยันแล้ว";
  else if (status === "PD_CANCELED") label = "ยกเลิก";
  return label;
};

const convertPicklistStatus = (status: String) => {
  let label = "";
  if (status === "PD_RELEASED") label = "ออกเบิกแล้ว";
  else if (status === "PD_REQUESTED") label = "อนุมัติเบิกแล้ว";
  else if (status === "WH_SHORTAGE") label = "อนุมัติจ่ายแล้ว";
  else if (status === "WH_APPROVED") label = "อนุมัติจ่ายบางส่วน";
  else if (status === "PD_CHECKED") label = "ตรวจสอบแล้ว";
  else if (status === "QA_CHECKED") label = "ตรวจคุณภาพแล้ว";
  else if (status === "PD_RECORDED") label = "บันทึกยอดใช้แล้ว";
  else if (status === "PICKLIST_COMPLETED") label = "ปิดเอกสารแล้ว";
  return label;
};

const getRemainTime = (log: DgtPdOrderOperationLog) => {
  let remainTime =
    getMinuteTimeV2(log.startedTime, log.finishedTime) -
    (log.downtimeBaseTime ? log.downtimeBaseTime : 0);
  return remainTime < 0 ? 0 : remainTime;
};

// delete a specific row
function ec(r: any, c: any) {
  return XLSX.utils.encode_cell({ r: r, c: c });
}
function delete_row(ws: any, row_index: any) {
  var variable = XLSX.utils.decode_range(ws["!ref"]);
  for (var R = row_index; R < variable.e.r; ++R) {
    for (var C = variable.s.c; C <= variable.e.c; ++C) {
      ws[ec(R, C)] = ws[ec(R + 1, C)];
    }
  }
  variable.e.r--;
  ws["!ref"] = XLSX.utils.encode_range(variable.s, variable.e);
}

export default GenerateExcel;
